import { Input } from 'antd';
import { FC, useEffect, useState } from 'react';
import editSvg from './edit.svg';
import { editNickName } from '../../service';

export interface INickNameProps {
  name?: string;
}

export const NickName: FC<INickNameProps> = (props) => {
  const [name, setName] = useState(props.name);

  useEffect(() => {
    setName(props.name);
  }, [props.name]);
  const [editAble, setEditAble] = useState(false);
  const submitName = async () => {
    await editNickName({
      nickName: name || '',
    });
    setEditAble(false);
  };

  return (
    <div className="w-full h-10 flex justify-start items-center px-4 mt-2">
      {!editAble && <span className="cursor-default">{name}</span>}
      {editAble && (
        <div>
          <Input
            maxLength={50}
            autoFocus
            value={name}
            disabled={!editAble}
            onChange={(e) => setName(e.target.value)}
            onBlur={submitName}
            onPressEnter={submitName}
          ></Input>
        </div>
      )}
      {!editAble && (
        <div
          className="ml-2 cursor-pointer"
          onClick={() => {
            setEditAble(true);
          }}
        >
          <img src={editSvg} alt="" />
        </div>
      )}
    </div>
  );
};
